import { sortByBoolean, sortByDate, sortByLocalCompare, sortByNumber, } from './utility/table-sort.utils';
export { Table as TableV2 } from './table.component';
export { useTableConfig } from './hooks/use-table-config.hook';
export { TableFilterBar } from './partials/table-filter-bar';
export { TableAppliedFilterBar } from './partials/table-applied-filter-bar';
export const sortUtility = {
    sortByBoolean,
    sortByDate,
    sortByLocalCompare,
    sortByNumber,
};
